import axios from 'axios';
import user from 'libs/user';
import config from 'config';

axios.defaults.withCredentials = true;
const path = `${config.baseURL}/common-auth-server/api/b/auth`;
const pahtUcenter = `${config.baseURL}/common-ucenter-server/api/b/users`;

const refresh = () => {
  return axios.post(
    `${path}/token/refresh`,
    {},
    { headers: { 'x-header-tid': user.getTenantId() } }
  );
};
// 退出登录
export const logout = () => {
  return axios.get(`${path}/logout`, {
    headers: { 'x-header-tid': user.getTenantId() }
  });
};
// /common-ucenter-server/api/b/users/me
export const getUser = () => {
  return axios.get(`${pahtUcenter}/me`, {
    headers: { 'x-header-tid': user.getTenantId() }
  });
};
export default refresh;
